import { useLocation } from 'react-router-dom';

const GetQuery = (value = 'id') => {
  const queryStings = useLocation().search as any;
  const queryStingId = new URLSearchParams(queryStings).get(value) as string;
  return queryStingId
};

export default GetQuery;